import { z } from "zod";
import {
  optionalBooleanFromString,
  optionalHourOfDay,
  optionalTrimmedString,
} from "./primitives";

export const notificationPreferencesSchema = z.object({
  teamId: optionalTrimmedString,
  roleId: optionalTrimmedString,
  inAppEnabled: optionalBooleanFromString,
  digestEnabled: optionalBooleanFromString,
  digestHourUtc: optionalHourOfDay,
});

export type NotificationPreferencesPayload = z.infer<
  typeof notificationPreferencesSchema
>;
